import React from 'react';
import moment from 'moment';
import classnames from 'classnames';
import ReactGA from 'react-ga';
import helper from '../Conversations/helpers';
import utils from '../../lib/utils';

import './index.scss';

import Loading from '../common/Loading';
import ProgressBar from './ProgressBar';
import Campaign from './CampaignCard';
import CampaignOverlay from './CampaignOverlay';

class Outreach extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modelopen: false,
      smssentcount: 0,
      outreach_sorted:[]
    };
  }

  componentDidMount =()=>{
    ReactGA.pageview(window.location.hash);
    ReactGA.event({
      category: 'User',
      action: 'Click on Outreach Tab',
      label: 'Outreach Page'
    });
    if(this.props.business && this.props.business.id){
        this.props.getOutreach(this.props.business.id);
    }
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.business.isInfoFetched && nextProps.business.isInfoFetched!==this.props.business.isInfoFetched && nextProps.business.id) {
        this.props.getOutreach(nextProps.business.id);
      }
    if(nextProps.outreach.getOutreach!==true && nextProps.outreach.getOutreach!==this.props.outreach.getOutreach){
      const { outreaches } = nextProps.outreach;
      this.sortCampaign(outreaches);
      // this.setState({
      //   smssentcount:count
      // })
    }
    console.log("nextProps",nextProps);
    if(nextProps.outreach.refresh && nextProps.outreach.getOutreach!==true){
      const { outreaches } = nextProps.outreach;
      this.sortCampaign(outreaches);
    }
    
  }

  sortCampaign = (outreaches)=>{
    if( outreaches && outreaches.campaigns){
    outreaches.campaigns.sort((a,b) => {
        return (new Date(a.updated_time) >new Date(b.updated_time))?-1:1;
    });
    this.groupBydate(outreaches);
    }
  }

  groupBydate=(outreaches)=>{
    const campaignData = outreaches.campaigns.reduce((campaignData, campaigns) => {
      let timezoneddate = moment(campaigns.updated_time).tz(outreaches.zone_id);
        var month = moment(timezoneddate).format('MM');
        const year = moment(timezoneddate).year();
        month = year.toString()+month.toString();
        if (!campaignData[month]) {
          campaignData[month] = [];
        }
        campaignData[month].push(campaigns);
        return campaignData;
      }, {});
      
      // Edit: to add it in the array format instead
      console.log(campaignData);
      const groupArrays = Object.keys(campaignData).map((month) => {
        return {
          month,
          campaignData: campaignData[month]
        };
      });
      groupArrays.sort((a,b) => {
        return a.month > b.month?-1:1;
    });
      console.log("dtate array",groupArrays);
      if(groupArrays.length>0 && groupArrays[0].month!==moment().format('YYYYMM')){
        groupArrays.push({
            month:moment().format('YYYYMM'),
            campaignData: []
        }) 
      }
      groupArrays.sort((a,b) => {
        return a.month > b.month?-1:1;
    });
      this.setState({
        outreach_sorted:groupArrays
      });
      for(let i=0;i<outreaches.campaigns.length;i++){
          if(outreaches.campaigns[i].status==='IN_PROGRESS'){
            if(outreaches.campaigns[i].hasOwnProperty('refreshCount')){
              console.log("refresh",outreaches.campaigns[i],this.props.outreach.outreaches.campaigns[i])
              if(outreaches.campaigns[i].refreshCount<100){
                setTimeout( ()=>this.props.refreshCampaign(this.props.business.id,outreaches.campaigns[i].id),5000);
              }
            }else{
                setTimeout( ()=>this.props.refreshCampaign(this.props.business.id,outreaches.campaigns[i].id),5000);
            }
          }
      }
}
  createCampaign = ()=>{
    this.setState({
      modelopen:true
    })
  }

  closeCampaignModel = ()=>{
    this.setState({
      modelopen:false
    })
  }

  getCampaign=(campaigns)=>{
    return campaigns.map(campaign=>{
      return <div Key={campaign.id}><Campaign timezone={this.props.outreach.outreaches.zone_id} campaign={campaign} editCampaign={this.editCampaign} deleteCampaign={this.deleteCampaign} downloadReport={this.downloadReport}/></div>
    })
  }

  getCount =(campaigns)=>{
    let count = 0;
      campaigns.map(campaign=>{
        count+=campaign.messages_sent;
      })
    return count;
  }

  editCampaign =(id)=>{
    this.props.history.push('/app/campaign/'+id);
  }

  deleteCampaign = (id)=>{
    this.props.deleteOutreach(this.props.business.id,id);
  }
  downloadReport=(id)=>{
    let file = window.Config.API_URL+'/business/outreach/'+id+'/report';
    window.open(file);
    // this.props.downloadReport(this.props.business.id,id)
  }

  render() {
    const {modelopen , smssentcount, outreach_sorted} = this.state;
    const { outreach, auth} = this.props;
    const { role } = auth;
    const features = utils.getCookie('feature')
    return (
      <div className="outreach">
        {outreach.getOutreach && 
        <div className="add-campaign_loader">
        <Loading />
        </div>
        } 
        {!outreach.getOutreach && 
        <>
        <div className='outreach_title'>
          <div className="outreach_title_content">
              <div className="title">Outreach</div>
              <button className="add_campaign" style={{opacity:((outreach.outreaches.sms_limit<1|| !outreach.outreaches.sms_limit)?0.5:1)}} onClick={this.createCampaign} disabled={outreach.outreaches.sms_limit<1|| !outreach.outreaches.sms_limit}>+ Add new campaign</button>
          </div>
          {outreach && outreach.outreaches && outreach.outreaches.text_only_number &&
          <div className="outreach_title_meta">
            <div className="icon"><i className="material-icons">phone_iphone</i></div>
            <div>Your 1-way text number: {helper.formatPhoneNumber(outreach.outreaches.text_only_number)}</div>
          </div>
            }
        </div>
        <div className="outreach_campaign">
          <div className="outreach_campaign_content">
            {outreach && outreach.outreaches && 
              <div className="outreach_campaign_content_list">
                {
                  outreach_sorted.map((month,index)=>{
                    return(
                      < div  key={index}>
                      <div className="date">{moment(month.month, 'YYYYMM').format('MMMM YYYY')} <span>({month.campaignData.length} Campaigns)</span></div>
                       {index==0 && moment(month.month, 'YYYYMM').isSame(moment().startOf('month'))&& <ProgressBar role={role} sent={outreach.outreaches.total_messages_sent_for_month} total={outreach.outreaches.sms_limit}/>}
                      {month.campaignData.map((campaign,index)=>{
                            return (<div key={index}>
                              <Campaign timezone={this.props.outreach.outreaches.zone_id} campaign={campaign} editCampaign={this.editCampaign} deleteCampaign={this.deleteCampaign} downloadReport={this.downloadReport}/>
                              </div>)
                      })}
                      </div>
                    )
                  })
                }
                { outreach && outreach.outreaches && outreach.outreaches.campaigns && outreach.outreaches.campaigns.length===0 && outreach.outreaches.sms_limit===0 &&
                  <ProgressBar role={role} sent={outreach.outreaches.total_messages_sent_for_month} total={outreach.outreaches.sms_limit}/>
                }
                <CampaignOverlay modelopen={modelopen} closeCampaignModel={this.closeCampaignModel} {...this.props}/>
              </div>
            }
          </div>
        </div>
        </>
        }
        {features && !features.includes('CONTACT_INFO_HIDDEN') && 
         <div className="help-form">Reach us at support@truelark.com or call +1-408-582-7010</div>
        }
      </div>
    );
  }
}
export default Outreach;
